import React from 'react';
import PropTypes from 'prop-types';

import {TextField} from '@mui/material';

const TextCharLimit = (props) => {
  const charLimit = props.charLimit;
  const value = props.value || '';
  const onChange = props.onChange;
  const sx = props.sx;
  const minRows = props.minRows;
  const maxRows = props.maxRows;
  const onBlur = props.onBlur;

  return (
    <TextField
      label={props.label}
      placeholder={props.placeholdText}
      inputProps={{
        maxLength: charLimit,
      }}
      value={value}
      helperText={`${value.length}/${charLimit}`}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      variant="outlined"
      autoFocus={props.autoFocus}
      fullWidth
      multiline={props.multiline}
      disabled={props.disabled}
      sx={sx}
      minRows={minRows}
      maxRows={maxRows}
      data-id={props.id}
      data-testid={props['data-testid']}
      error={props.error}
    />
  );
};


TextCharLimit.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  placeholdText: PropTypes.string,
  charLimit: PropTypes.number.isRequired,
  multiline: PropTypes.bool,
  disabled: PropTypes.bool,
  sx: PropTypes.object,
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
  id: PropTypes.string,
  onBlur: PropTypes.func,
  autoFocus: PropTypes.bool,
  ['data-testid']: PropTypes.string,
  error: PropTypes.bool,
};

export default React.memo(TextCharLimit);
